
import Confirm from 'vux/src/components/confirm/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import {memberAdviceCreate} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
tabIndex: 1,
adviceContent:'',
adviceType:'problem',
accessToken:this._wxTool.getAccessToken()
}
},
created(){

},
methods: {
tab(e){
let tabIndex = e;
this.tabIndex=tabIndex
if(e==1){
this.adviceType = 'problem'
}else{
this.adviceType = 'function'
}
this.adviceContent = ''
},
change(){
var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
if(this.adviceContent.match(reg)) {
this.adviceContent = this.adviceContent.replace(reg, '');
}
},
okBtn(){
this.adviceContent = this.adviceContent.replace(/^\s*|\s*$/g,"");
if(this.adviceContent ==''){
this.$vux.toast.text('请填写相关内容', 'middle')
return
}
let params ={
accessToken:this.accessToken,
adviceType:this.adviceType,
adviceContent:this.adviceContent
}
memberAdviceCreate(params).then(res=>{
if(res.code == 0){
console.log(res);
this.$vux.toast.text('感谢您的投诉与建议', 'middle')
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/my/proposal/proposal.vue